import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, ogImage }) => {
  const defaultTitle = 'Mediawise Solutions | Business Strategy & Marketing for Regional Australia';
  const defaultDescription = 'Wiser solutions for smarter business. We help regional Australian businesses grow through strategy, systems, and smarter marketing.';
  const defaultKeywords = 'business strategy, marketing, regional business, Central Queensland, business systems, Wise Check, business consulting';
  const siteUrl = 'https://wisecrm.preview.emergentagent.com';
  
  return (
    <Helmet>
      <title>{title || defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title || defaultTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || defaultTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {/* Favicon */}
      <link rel="icon" type="image/png" href="/favicon.png" />
    </Helmet>
  );
};

export default SEO;